import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { changeUserStatus, deleteUser, fetchUsers } from './usersApi';
import { RootState, useAppDispatch } from '../../../app/store';
import Users from './Users';
import { notification } from 'antd';
import { NOTIFICATION_TYPES } from '../../../utils/constant';
import { useTranslation } from 'react-i18next';

interface UsersContainerProps {

}

const UsersContainer: React.FC<UsersContainerProps> = (props) => {
  const dispatch = useAppDispatch();
  const { users } = useSelector((state: RootState) => state.users);
  const [filteredUsers, setFilteredUsers] = useState(users);
  const [searchQuery, setSearchQuery] = useState("");
  const { t } = useTranslation();
  useEffect(() => {
    dispatch(fetchUsers());
  }, [dispatch]);

  useEffect(() => {
    setFilteredUsers(
      users.filter(user =>
        `${user?.firstname} ${user?.lastname}`.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user?.email.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user?.role?.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
        user?.nodes.some((node: any) => node?.name?.toLowerCase().includes(searchQuery.toLowerCase())) 
      )
    );
  }, [users, searchQuery]);

  const handleSearch = (value: string) => {
    setSearchQuery(value);
  };

  //Handle delete/status change events from user list actions
  const handleUserUpdate = (value: number, operation: string) => {
    const action = operation === 'delete' ? deleteUser(value) : changeUserStatus(value);
    dispatch(action)
      .unwrap()
      .then((response) => {
        if (response?.status === 'success') {
          notification[NOTIFICATION_TYPES.SUCCESS]({ message: t('success'), description: response?.message });
          dispatch(fetchUsers());
        }
      });
  }

  return <Users
    users={filteredUsers}
    searchValue={searchQuery}
    loading={false}
    onSearch={handleSearch}
    handleUserUpdate={handleUserUpdate} />;
};

export default UsersContainer;